import type {
  ApiPrivacyPolicy,
  UiPrivacyPolicy,
} from '../../schemas/privacyPolicies.schema';

export function mapPrivacyPolicyFromApi(
  apiPrivacyPolicy: ApiPrivacyPolicy,
): UiPrivacyPolicy {
  return {
    ...apiPrivacyPolicy,
    language: [{ value: apiPrivacyPolicy.language }],
    status: apiPrivacyPolicy.status === 'ACTIVE' ? 'active' : 'archived',
  };
}
